import {
  IConversionProps, IFactoryOptions, IConversionObject,
} from '../../types';

/**
 * Base factory for conversion object
 * @param {Object} options - input for schema property bag and i18n
 */
export class BaseFactory {
  i18n: I18nModel;

  prop: IConversionProps;

  constructor(options: IFactoryOptions) {
    this.prop = options.prop;
    this.i18n = options.i18n;
  }

  /**
   * Base method to create conversion object
   * @returns {Object} - pass-through conversion object
   */
  create(): IConversionObject {
    const passThrough = <T>(value: T): T => value;

    return {
      fromModel: passThrough,
      toModel: passThrough,
    };
  }
}
